import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const STORAGE_KEY = "currentUserUniversityInfo";

const publicService = {
    async getCurrentUserInfo(): Promise<any> {
        try {
            const cachedData = localStorage.getItem(STORAGE_KEY);
            if (cachedData) {
                return JSON.parse(cachedData);
            }

            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/public/currentUserInfo`);
            const data = response.data;

            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            return data;
        } catch (error) {
            console.error("Error getCurrentUserInfo", error);
            throw error;
        }
    }
}

export default publicService;